export default "__VITE_PUBLIC_ASSET__eb6197c3__"